import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Typography } from 'antd';
import { activateDeactivateUserRequest } from '../../UserApiActions';
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon';
import Notification from '../../../../utils/Notification';

const notification = new Notification();

let ActivateOrDeactivateUserComponent = (props) => {
  const { visible, onCancel, user } = props
  const action = user.enabled ? 'Deactivate' : 'Activate'

  const activateOrDeactivateUser = () => {
    props.activateDeactivateUser(user.id, !user.enabled).then(() => {
      if (user.enabled)
        notification.show('info', `${action} User Account`, 'User account activated');
      else
        notification.show('info', `${action} User Account`, 'User account deactivated');
      onCancel()
    })
  };

  return (
    (<Modal
      open={visible}
      title={
        <div className="flex-horizontal-gap-4">
          <CustomIcon name="LockClosed" width={40} height={40} />
          <Typography.Title level={2} style={{ margin: 0 }}>{action} User Account</Typography.Title>
        </div>
      }
      onCancel={onCancel}
      footer={null}
      width={800}
      bodyStyle={{
        maxHeight: '70vh',
        overflowY: 'auto'
      }}
    >
      <div className="flex-vertical-gap-4">
        <p>Are you sure you want to {action.toLowerCase()} user account?</p>
        <Button type="primary" block onClick={activateOrDeactivateUser}>
          {action} User Account
          <CustomIcon name="Check" />
        </Button>
        <Button block onClick={onCancel}>
          Cancel
          <CustomIcon name="CloseX" />
        </Button>
      </div>
    </Modal>)
  );
}

const mapStateToProps = (state) => {
  return {
    loggedInUser: state.auth.loggedInUser,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    activateDeactivateUser: (userId, status) => {
      return dispatch(activateDeactivateUserRequest(userId, status)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    }
  }
};

let ActivateOrDeactivateUser = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivateOrDeactivateUserComponent);

export default ActivateOrDeactivateUser;